import React from 'react';
import { FaUniversity, FaTools } from 'react-icons/fa';
import { SiGooglescholar } from 'react-icons/si';
import iitImage from '../assets/img/14.jpeg';
import iitImage2 from '../assets/img/4.jpeg';
import iitImage3 from '../assets/img/5.jpeg';
import iitImage4 from '../assets/img/16.jpeg';
import adf from '../assets/img/grp2.png';
import adf2 from '../assets/img/7.jpeg';
import adf3 from '../assets/img/2.jpeg';
import adf4 from '../assets/img/Wavecrest 3.png';
// import pic from '../assets/img/Lead.jpg';
import Navbar from './NavBar';
import Contact from './Contact';

const Homeproject = () => {
  return (
    <>
      <div name='homeproject' className='w-full min-h-screen bg-white pt-4 pb-16'>
        <div className='container mx-auto lg:px-16 xl:px-16 2xl:px-20 md:px-16 px-6'>
          <h1 className='text-3xl font-semibold text-center mb-8 mt-12'>Our Current Projects</h1>

          {/* Project: Institute for Industrial Technology (IIT) */}
          <div className='flex flex-col md:flex-row justify-center items-center lg:gap-10 md:gap-10 gap-2 mb-12'>
            <div className='md:w-3/5 md:h-[428px]'>
            <div className='grid grid-cols-2'>
            <img src={iitImage} alt="Feature 1" className="hidden md:block lg:block w-full h-[214px] " />
              <img src={iitImage2} alt="Feature 2" className="hidden md:block lg:block w-full h-[214px] mt-4 ml-2 " />
              <img src={iitImage3} alt="Feature 3" className="hidden md:block lg:block w-full h-[214px] lg:mt-[-8px]  " />
              <img src={iitImage4} alt="Feature 4" className="hidden md:block lg:block w-full h-[214px] ml-2 mt-2" />
            </div>
            </div>
            <div className='md:w-2/5'>
              <div className='flex text-lg mb-4'>
                <FaTools className='inline-block mr-2 text-[#15381b] text-3xl' />
                <h2 className='text-2xl font-semibold'>Institute for Industrial Technology (IIT)</h2>
              </div>
              <img src={iitImage} alt='IIT' className='md:hidden lg:hidden rounded-lg mb-4 md:mb-0 md:mr-4 w-full h-[250px]' />

              <p className='text-gray-700'>
                Established in 2000 by ADF, the Institute for Industrial Technology (IIT) provides
                 vocational training to economically disadvantaged youth in Nigeria. Through its programs, IIT equips students with
                  essential technical skills crucial for success in the manufacturing and allied industries.
                Beneficiaries of the school leavers programme are 
            usually between the age of 16 and 23. This target group tend to embrace lifestyles that may be anti-social if not attended to.
              </p>
              <img src={iitImage2} alt='IIT2' className='md:hidden lg:hidden rounded-lg mb-4 md:mb-0 md:mr-4 w-full h-[250px]' />
              <p className='text-gray-700 mt-4'>
                <strong>Website:</strong> <a href='https://www.iit.edu.ng'  
                target="_blank"
                rel="noopener noreferrer"
                className='text-[#15381b] hover:underline'>www.iit.edu.ng</a>
              </p>
              {/* <a href='/project' className='inline-block mt-4 text-[#15381b] font-semibold hover:underline'>
                See More →
              </a> */}
            </div>
          </div>

          {/* Project: ADF Scholarship Board */}
          <div className='flex flex-col md:flex-row justify-center items-center lg:gap-10 md:gap-10 gap-2'>
            <div className='md:w-3/5 md:h-[428px] lg:mt-10'>
            <div className='grid grid-cols-2'>
              <img src={adf} alt="Feature 1" className="hidden md:block lg:block w-full h-[214px] " />
              <img src={adf2} alt="Feature 2" className="hidden md:block lg:block w-full h-[214px] mt-4 ml-2 " />
              <img src={adf3} alt="Feature 3" className="hidden md:block lg:block w-full h-[214px] lg:mt-[-8px]  " />
              <img src={adf4} alt="Feature 4" className="hidden md:block lg:block w-full h-[214px] ml-2 mt-2" />
            </div>
            </div>
            <div className='md:w-2/5'>
              <div className='flex text-lg mb-4'>
                <SiGooglescholar className='inline-block mr-2 text-[#15381b] text-3xl' />
                <h2 className='text-2xl font-semibold'>ADF Endowment Fund</h2>
              </div>
              <img src={adf} alt='ADF' className='md:hidden lg:hidden rounded-lg mb-4 md:mb-0 md:mr-4 w-full h-[250px]' />
              <p className='text-gray-700'>
                              The ADF Endowment Fund is a strategic financial initiative established by the African
              Development Foundation (ADF) to ensure the long-term sustainability of its mission of
              empowering youth through values-based technical and vocational education. The Endowment Fund is designed
              to provide a reliable and perpetual source of funding for these life-changing initiatives.
              </p>
              {/* <a href='/project' className='inline-block mt-4 text-[#15381b] font-semibold hover:underline'>
                See More →
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Homeproject;



// import React from 'react';
// import { FaTools } from 'react-icons/fa';
// import { SiGooglescholar } from 'react-icons/si';
// import iitImage1 from '../assets/img/14.jpeg';
// import iitImage2 from '../assets/img/4.jpeg';
// import adfImage1 from '../assets/img/4.jpeg';
// import adfImage2 from '../assets/img/2.jpeg';

// const Homeproject = () => {
//   return (
//     <div name='homeproject' className='w-full min-h-screen bg-white py-12'>
//       <div className='container mx-auto lg:px-36 md:px-16 px-6'>
//         <h1 className='text-3xl font-semibold text-center mb-12 mt-12'>Our Current Projects</h1>

//         {/* Project 1: IIT */}
//         <div className='mb-16'>
//           {/* Header */}
//           <div className='flex items-center text-lg mb-4'>
//             <FaTools className='text-[#15381b] text-3xl mr-2' />
//             <h2 className='text-2xl font-semibold'>Institute for Industrial Technology (IIT)</h2>
//           </div>

//           {/* Mobile layout */}
//           <div className='md:hidden'>
//             <img src={iitImage1} alt='IIT 1' className='rounded-lg w-full h-[250px] object-cover mb-4' />
//             <p className='text-gray-700'>
//               Established in 2000 by ADF, the Institute for Industrial Technology (IIT) provides vocational training to economically disadvantaged youth in Nigeria. Through its programs, IIT equips students with essential technical skills crucial for success in the manufacturing and allied industries.
//             </p>
//             <img src={iitImage2} alt='IIT 2' className='rounded-lg w-full h-[250px] object-cover mt-4 mb-2' />
//             <p className='text-gray-700'>
//               <strong>Website:</strong>{' '}
//               <a href='https://www.iit.edu.ng' className='text-[#15381b] hover:underline'>
//                 www.iit.edu.ng
//               </a>
//             </p>
//           </div>

//           {/* Desktop layout */}
//           <div className='hidden md:flex flex-row justify-center items-center lg:gap-10 gap-6'>
//             {/* Image Grid */}
//             <div className='md:w-1/2 grid grid-cols-2 gap-4'>
//               <img src={iitImage1} alt='IIT 1' className='rounded-lg w-full h-[220px] object-cover' />
//               <img src={iitImage2} alt='IIT 2' className='rounded-lg w-full h-[220px] object-cover' />
//             </div>
//             {/* Text */}
//             <div className='md:w-1/2'>
//               <p className='text-gray-700'>
//                 Established in 2000 by ADF, the Institute for Industrial Technology (IIT) provides vocational training to economically disadvantaged youth in Nigeria. Through its programs, IIT equips students with essential technical skills crucial for success in the manufacturing and allied industries.
//               </p>
//               <p className='text-gray-700 mt-4'>
//                 <strong>Website:</strong>{' '}
//                 <a href='https://www.iit.edu.ng' className='text-[#15381b] hover:underline'>
//                   www.iit.edu.ng
//                 </a>
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Project 2: ADF */}
//         <div>
//           {/* Header */}
//           <div className='flex items-center text-lg mb-4'>
//             <SiGooglescholar className='text-[#15381b] text-3xl mr-2' />
//             <h2 className='text-2xl font-semibold'>ADF Endowment Fund</h2>
//           </div>

//           {/* Mobile layout */}
//           <div className='md:hidden'>
//             <img src={adfImage1} alt='ADF 1' className='rounded-lg w-full h-[250px] object-cover mb-4' />
//             <p className='text-gray-700'>
//               The ADF Endowment Fund is a strategic financial initiative established by the African Development Foundation (ADF) to ensure the long-term sustainability of its mission of empowering youth through values-based technical and vocational education. The Endowment Fund is designed to provide a reliable and perpetual source of funding for these life-changing initiatives.
//             </p>
//             <img src={adfImage2} alt='ADF 2' className='rounded-lg w-full h-[250px] object-cover mt-4' />
//           </div>

//           {/* Desktop layout */}
//           <div className='hidden md:flex flex-row justify-center items-center lg:gap-10 gap-6'>
//             {/* Image Grid */}
//             <div className='md:w-1/2 grid grid-cols-2 gap-4'>
//               <img src={adfImage1} alt='ADF 1' className='rounded-lg w-full h-[220px] object-cover' />
//               <img src={adfImage2} alt='ADF 2' className='rounded-lg w-full h-[220px] object-cover' />
//             </div>
//             {/* Text */}
//             <div className='md:w-1/2'>
//               <p className='text-gray-700'>
//                 The ADF Endowment Fund is a strategic financial initiative established by the African Development Foundation (ADF) to ensure the long-term sustainability of its mission of empowering youth through values-based technical and vocational education. The Endowment Fund is designed to provide a reliable and perpetual source of funding for these life-changing initiatives.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Homeproject;
